module.exports = __webpack_public_path__ + "static/media/019-Cabot Links.48acc955.jpg";